export const getters = {
  getLists($state) {
    return $state.sortOrder.map(id => $state.records[id]);
  },
  getMeta($state) {
    return $state.meta;
  },
  getCurrentList($state) {
    return $state.currentList || {};
  },
  getMembers($state) {
    return $state.memberSortOrder.map(id => $state.memberRecords[id]);
  },
  getMembersMeta($state) {
    return $state.memberMeta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
